import { cn } from "@/lib/utils";
import Icon from "@/components/ui/Icon";

type CarouselNavigationButtonProps = {
  reverse?: boolean;
} & React.ComponentProps<"button">;

const CarouselNavigationButton: React.FC<CarouselNavigationButtonProps> = ({
  className,
  ref,
  reverse,
  ...rest
}) => {
  return (
    <button
      type="button"
      className={cn(
        "cursor-pointer relative font-normal outline-none inline-flex items-center justify-center select-none touch-manipulation transition-colors text-semantic-text-primary duration-200 shrink-0 disabled:text-semantic-foreground-weak disabled:cursor-not-allowed",
        className
      )}
      ref={ref}
      {...rest}
    >
      <Icon
        id="icon-circle-arrow-right_48"
        width={48}
        height={48}
        className={cn("shrink-0", { "transform -scale-100": reverse })}
      />
    </button>
  );
};

export { CarouselNavigationButton };
